// extracted by mini-css-extract-plugin
export var container = "inventoryAmounts-module--container--8bba2";
export var inWarehouses = "inventoryAmounts-module--inWarehouses--e7806";
export var loaned = "inventoryAmounts-module--loaned--ec1e1";
export var pending = "inventoryAmounts-module--pending--82a01";
export var statusDot = "inventoryAmounts-module--statusDot--697ca";
export var statusLabel = "inventoryAmounts-module--statusLabel--9acf5";
export var statusList = "inventoryAmounts-module--statusList--a7879";
export var statusRow = "inventoryAmounts-module--statusRow--bd693";
export var statusValue = "inventoryAmounts-module--statusValue--f530f";
export var totalRow = "inventoryAmounts-module--totalRow--ebd6d";